import * as yup from 'yup';
const validateUuId = (id: string): boolean => {
  const schema = yup.object().shape({
    uuid: yup.string().uuid(),
  });
  return schema.isValidSync({ uuid: id });
};

export default validateUuId;
